module.exports = __webpack_public_path__ + "img/openVillage.c05586b6.png";